import { swalErrNotification, swalNotification } from '@/core/helpers/utils';
import { IBienBanGiaiTheResponseBase } from '@/core/interfaces/ApiResponses';
import { BienBanGiaiTheService } from '@/core/services/BienBanGiaiThe.service';
import { ref, Ref } from 'vue';

export const useBienBanComplete = (onSuccess?: () => void | Promise<void>) => {
  const showCompleteDialog = ref(false);
  const currentBienBan: Ref<IBienBanGiaiTheResponseBase | null> = ref(null);
  const pending = ref(false);

  const openCompleteDialog = (bienBan: IBienBanGiaiTheResponseBase) => {
    currentBienBan.value = bienBan;
    showCompleteDialog.value = true;
  };

  const closeCompleteDialog = () => {
    showCompleteDialog.value = false;
    currentBienBan.value = null;
  };

  const handleComplete = async (data: { date: Date }) => {
    if (!currentBienBan.value || pending.value) {
      return;
    }

    pending.value = true;
    try {
      await BienBanGiaiTheService.completeBienBan({
        id_bien_ban: currentBienBan.value.id,
        ngay_ra_xuong: data.date,
      });
      
      closeCompleteDialog();
      
      await swalNotification('Hoàn thành thành công', 'success');
      
      if (onSuccess) {
        await onSuccess();
      }
    } catch (error) {
      closeCompleteDialog();
      await swalErrNotification(error, 'Hoàn thành không thành công');
    } finally {
      pending.value = false;
    }
  };

  return {
    showCompleteDialog,
    currentBienBan,
    openCompleteDialog,
    closeCompleteDialog,
    handleComplete,
  };
};

